import { Box, Stack, useTheme } from "@mui/material";
import Title1 from "../../../components/title/title1";
import { useTranslation } from "react-i18next";
import PlatformsList from "./platforms-list";

const servicesLocales = "platforms.home";

const PlatformsLayout = () => {
    const theme = useTheme();
    const {t} = useTranslation();

    return (
        <>
            <Box
                sx={{
                    backgroundColor: theme.palette.background.default
                }}
                className="sectionDoubleSpacing"
            >
                <Stack
                    className="bodySideMargin1 sectionRadius"
                    direction='column'
                    alignItems='center'
                >
                    <Title1 
                        title={t(`${servicesLocales}.title`)}
                        description={t(`${servicesLocales}.description`)}
                    />

                    <PlatformsList />
                </Stack>
            </Box>
        </>
    );
}

export default PlatformsLayout;